import { authConstants, menuConstants } from "../../context/constants";
import { ModuloPermiso } from "../../types/admin-usuarios/ModuloPermiso";
import { Perfil } from "../../types/admin-usuarios/Perfil";
import { sortObjects } from "../formats";
import peticionBack from "../peticiones/peticionBack";

export async function getMenu(dispatch: any, perfil: Perfil, setLoading?: any){
    if(setLoading) setLoading(true);
    dispatch({type: menuConstants.MENU_REQUEST});
    const res = await peticionBack({ profile: perfil._id }, `/auth/get_permissions`, "POST", false, null, {}, true);
    
    if(res.status && !res.code){
        const data = res.data.permisos.filter((el: any) => !!el.module);
        let modulos: ModuloPermiso[] = data.map((el: any)=>{
            return {
                name: el.module.name,
                route: el.module.route,
                read: el.permission.read,
                create: el.permission.create,
                update: el.permission.update,
                delete: el.permission.delete,
                parent: el.module.parent,
                _id: el.module._id,
                level: el.module.level,
            };
        });

        modulos = sortObjects(modulos, "name");
        
        const cleanModules = modulos.filter((a) => a.create || a.read || a.update || a.delete);
       
        let cleaned = cleanModules.filter((m: ModuloPermiso) => {
            if(m.parent){
                const finalModules = cleanModules.find((modul) => modul._id === m.parent);
                return finalModules !== undefined;
            }
            return true;
        });

        cleaned = sortObjects(cleaned, "route");

        dispatch({
            type: menuConstants.MENU_SUCCESS,
            payload: { 
                permisos: {
                    modulos: cleaned
                }
            }
        });
        
    }else{
        dispatch({type: authConstants.LOGOUT});
    }
    if(setLoading) setLoading(false);
}